import { DataModel } from 'legacy/lut/classes/models/DataModel'
import { ContactAdditionalRow } from 'legacy/lut/components/widgets/public/contactData/ContactAdditionalRow'
import { JSX, useState } from 'react'

import { RowState } from 'core-components/library/list/types'

export interface IPartnerDataRowProps {
  item: DataModel
  renderChildren: (item: DataModel, rowState: RowState, additional: IObjectAny) => JSX.Element
  rowState: RowState
  rowAttrs: IObjectAny
  additional: IObjectAny
  colsNumber: number
}

export function ContactDataRow({
  rowAttrs,
  renderChildren,
  item,
  rowState,
  additional,
  colsNumber,
}: IPartnerDataRowProps) {
  const [opened, setOpened] = useState<boolean>(false)
  return (
    <>
      <tr {...rowAttrs} key={item.get('ContactID')} onClick={() => setOpened(!opened)}>
        {renderChildren(item, rowState, additional)}
      </tr>
      {opened && (
        <tr>
          <td colSpan={colsNumber}>
            <ContactAdditionalRow contactId={item.get('ContactID')} contact={item} />
          </td>
        </tr>
      )}
    </>
  )
}
